import {
  encodeBase64,
  decodeBase64,
  runQueryWithVariables
} from '../'


export const hasResponsibility = (identityNodeId, description, relatedModel = null, relatedInstance = null) => {
  if (identityNodeId === 'self') {
    let responsibilityArray = JSON.parse(localStorage.getItem('userResponsibilities'))
    if (!responsibilityArray) return false

    return responsibilityArray.some(responsibility =>
      responsibility.node.description === description &&
      (relatedModel
        ? responsibility.node.relatedModel === relatedModel
        : true
      ) &&
      (relatedInstance
        ? responsibility.node.relatedId === relatedInstance
        : true
      )
    )
  }
  else {
    // hit schema when identityNodeId not 'self', return a promise
    // NOTE: currently query doesn't consider relatedModel & relatedInstance
    const variables = {
      identityId: decodeBase64(identityNodeId),
      description
    }
    return runQueryWithVariables(
      `query($identityId: UUID!, $description: String!) {
        responsibilities(identity_Id: $identityId, description: $description) {
          edges {
            node {
              id
            }
          }
        }
      }
      `,
      variables
    )
      .then(({ data }) => {
        if (data.responsibilities.edges.length === 1) {
          return true
        }
      })
      .catch(() => false)
  }
}

export const getCurrentUserResponsibilityRelatedId = (description, relatedModel, returnNodeId = true) => {
  const responsibilityArray = JSON.parse(localStorage.getItem('userResponsibilities'))
  if (!responsibilityArray) return null

  const responsibility = responsibilityArray.find(responsibility => (
    responsibility.node.description === description &&
    responsibility.node.relatedModel === relatedModel
  ))

  return responsibility
    ? returnNodeId
      ? encodeBase64(responsibility.node.relatedId, 'EmployerGroupNode')
      : responsibility.node.relatedId
    : null
}

export const hasAnyResponsibility = (identityUUID, responsibilities) => (
  !!responsibilities.find(responsibility => (
    hasResponsibility(identityUUID, responsibility.description, responsibility.relatedModel, responsibility.relatedInstance)
  ))
)

export const hasAllResponsibilities = (identityUUID, responsibilities) => (
  responsibilities.every((responsibility) => (
    hasResponsibility(identityUUID, responsibility.description, responsibility.relatedModel, responsibility.relatedInstance)
  ))
)

export const getIdentityResponsibility = (responsibility, model, id) => {
  let identityResponsibilities = JSON.parse(localStorage.getItem('identityResponsibilities'))

  if (identityResponsibilities) {
    if (model && id) {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model &&
        identityResponsibility.node.relatedId === id
      ))
    } else if (model) {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model
      ))
    } else {
      return identityResponsibilities.find((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility
      ))
    }
  } else {
    return null
  }
}

export const getIdentityResponsibilities = (responsibility, model, id) => {
  let identityResponsibilities = JSON.parse(localStorage.getItem('identityResponsibilities'))

  if (identityResponsibilities) {
    if (model && id) {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model &&
        identityResponsibility.node.relatedId === id
      ))
    } else if (model) {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility &&
        identityResponsibility.node.relatedModel.model === model
      ))
    } else {
      return identityResponsibilities.filter((identityResponsibility) => (
        identityResponsibility.node.responsibilitytype.name === responsibility
      ))
    }
  } else {
    return []
  }
}

export const hasAllIdentityResponsibilities = (...responsibilities) => {  // expects array of [responsibility type, related model, related id]
  // is any responsibility of the ones passed into this function not assigned to the user identity?
  let hasUnassignedResponsibility = responsibilities.find((responsibility) => (
    !getIdentityResponsibility(responsibility[0], responsibility[1], responsibility[2])  // getIdentityResponsibility returns 'null'/'undefined' if responsibility not found on identity
  ))

  if (hasUnassignedResponsibility) {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/utils/user/index.js